export async function productIndexUseCase(page, per_page, search, sort_by, productRepository) {
    const result = await productRepository.index(page, per_page, search, sort_by);

    result.data.forEach(x => {
        x = new productRepository.model_index(x);
        
        if (!x.isValid()) {
            console.log(x)
            throw new Error("Producto inválido. id: " + x.id + " sku: " + x.sku);
        }
    })

    return result;
}